import isSSR from "../../../utils/isSSR";
import { GLOBALNAV_KBB_BASE_URL } from '../mykbb/utils/constants';
import { getClientEnvVariable } from '@kbbsdk/config/clientEnvVariables';
const getLink = (page, isIncludeRefUrl = false) => {
  const refUrl = isIncludeRefUrl && !isSSR() ? `?refUrl=${encodeURIComponent(window.location.href)}` : '';
  return `${GLOBALNAV_KBB_BASE_URL}/account/${page}${refUrl}`;
};
export const SIGN_OUT_URL = getLink('sign-out', true);
export const SIGN_IN_URL = getLink('sign-in', true);
export const CREATE_ACCOUNT_URL = getLink('sign-up');
export const MY_PROFILE_URL = getLink('profile');
export const NEW_CAR_SEARCH_URL = getLink('cars');
export const MY_CARS_URL = getLink('mycars');
export const DEALER_REVIEWS_URL = getLink('dealer-reviews');
export const MANAGE_MY_AD = process.env.CONFIG === 'nonprod' ? 'https://test.autotrader.com/sell-my-car/manage-ad' : 'https://www.autotrader.com/sell-my-car/manage-ad';
export const getWebComponentUrl = ({
  userwcbranch = 'master'
} = {}) => {
  return getClientEnvVariable('CONFIG') === 'nonprod' || process.env.CONFIG === 'nonprod' ? `https://use1-user-webcomponents-node-${userwcbranch}.awscsusernp.kbb.com/build/node.esm.js?v=${Date.now()}` : `https://use1-user-webcomponents-node-${userwcbranch}.awscsuser.kbb.com/build/node.esm.js?v=${Date.now()}`;
};